
import React, { useEffect, useState } from 'react';
import { Container, Typography, CardContent, Card, Stack, TextField, IconButton, InputAdornment, Alert, Grid, Breadcrumbs, Link, Box } from '@mui/material';
import { useFormik, Form, FormikProvider } from 'formik';
import { LoadingButton } from '@mui/lab';
import * as Yup from 'yup';
// import Iconify from '../components/Iconify';
import Iconify from 'src/components/Iconify';
// import axios from '../axios';
import axios from 'axios';
import { getURL, jsonToParam } from 'src/utils/config';
import { setDeleteToken } from 'src/api/vehicles';
import Page from 'src/components/Page';
import DashboardBreadcrumbLink from 'src/components/DashboardBreadcrumbLink';
import { getAppStorageItem } from 'src/utils/storageProxy';

export default function PasswordManagement() {
    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [isError, setErrorMsg] = useState({ status: false, msg: "" })
    const [successMsg, setSuccessMsg] = useState('');
    const [locationNames,setLocationNames] = useState('')

    const AUTHORIZATION = `Bearer ${localStorage.getItem('access_token')}`;

    const PasswordSchema = Yup.object().shape({
        oldPassword: Yup.string()
            .required('Old Password is required'),
        newPassword: Yup.string()
            .required('New Password is required'),
        confirmPassword: Yup.string()
            .required('Confirm Password is required')
            .test(
                'passwords-match',
                'Passwords must match',
                function (value) {
                    const { newPassword } = this.parent;
                    // Only check if confirmPassword is not empty
                    if (value && value.length > 0) {
                        return value === newPassword;
                    }
                    return true; // Let required() handle empty case
                }
            )
    });

    const formik = useFormik({
        initialValues: {
            oldPassword: '',
            newPassword: '',
            confirmPassword: '',
        },
        validationSchema: PasswordSchema,
        onSubmit: () => {
            setErrorMsg((er) => er.status = false)
            handlePasswordChange(values)
        }
    });

    useEffect(()=>{
        const assignedLocations = getAssignedLocationsFromStorage();
        if(assignedLocations){
            if(assignedLocations.length>0){
                const LocationNames = assignedLocations.map(val=>val.Location)
                setLocationNames(LocationNames)
            }
        }
    },[])

    const getAssignedLocationsFromStorage = () => {
      try {
        const assignedLocationsRaw = getAppStorageItem('assigned_locations');
        if (!assignedLocationsRaw) return [];
    
        const parsedAssignedLocations = JSON.parse(assignedLocationsRaw);
        const assignedLocations = Array.isArray(parsedAssignedLocations)
          ? parsedAssignedLocations
          : [];
    
        return assignedLocations
          .map((locationItem) => ({
            ID: Number(locationItem?.ID ?? locationItem?.id ?? 0),
            Location: String(locationItem?.Location || locationItem?.name || '').trim(),
          }))
          .filter((locationItem) => locationItem.ID > 0);
      } catch (error) {
        console.error('Failed to read assigned_locations from storage:', error);
        return [];
      }
    };

    const handlePasswordChange = (body) => {
        setSuccessMsg('');
        let locations = ''
        if(locationNames.length>0){
            locations = locationNames.join(',')
        }
        setErrorMsg({ status: false, msg: "" });
        const userId = Number(localStorage.getItem('ID'));
        const passwordBody = { 
            ID: userId, 
            OldPassword: body.oldPassword.trim(), 
            Password: body.newPassword.trim(),
            Location : locations
        };

        axios({
            method: 'put',
            url: getURL('/client/update'),
            data: jsonToParam(passwordBody),
            headers: {
                Authorization: `${AUTHORIZATION}`,
            },
            validateStatus: function (status) {
                return status >= 200 || status === 400;
            },
        }).then(function (response) {
            console.log(response);
            if (response.status === 200) {
                setSuccessMsg('Password Changed Successfully');
                formik.resetForm();
                setSubmitting(false);
                setTimeout(() => {
                    clearAlertMsgs();
                    handleLogout();
                }, 3000);
            } else {
                setSubmitting(false);
                console.log(response.data);
                setErrorMsg({ status: true, msg: (response.data.detail ?? 'An error occurred while changing the password. Please try again.') })

                // setTimeout(() => {
                //     clearAlertMsgs();
                // }, 3000);
            }
        });
    }

    const handleLogout = () => {
        let client_id = localStorage.getItem('client_id');

        let redirect_url = '/login'
        if(client_id === "1320"){
          redirect_url = "/signin";
        }

        let fcm_token = localStorage.getItem('FCM_TOKEN')
        if (fcm_token) {
            const token = {
                token: fcm_token
            }
            setDeleteToken(token, (response) => {
                if (response.status === 200) {
                    removeLocalStorage();
                    window.location.href = redirect_url;
                }
            })
        }
        else {
            removeLocalStorage();
            window.location.href = redirect_url;
        }
    }

    const removeLocalStorage = () => {
        const keysToKeep = ['rememberedUsername', 'rememberedPassword', 'NetLocation', 'netIP', 'theme_mode'];
    
        // Get all keys from localStorage
        const allKeys = Object.keys(localStorage);
    
        // Remove keys that are not in the keep list
        allKeys.forEach(key => {
          if (!keysToKeep.includes(key)) {
            localStorage.removeItem(key);
          }
        });
    }

    const clearAlertMsgs = () => {
        setSuccessMsg('');
        setErrorMsg({ status: false, msg: "" });
    }

    const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps, setSubmitting } = formik;

    const handleShowOldPassword = () => {
        setShowOldPassword((show) => !show);
    };

    const handleShowNewPassword = () => {
        setShowNewPassword((show) => !show);
    };

    const handleShowConfirmPassword = () => {
        setShowConfirmPassword((show) => !show);
    };


    return (
        <Page title="Change Password">
            <Container maxWidth="xxl" sx={{ p: 0 }}>

            <Box sx={{ mb: 4 }}>
                <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                    <Typography variant="h4">Change Password</Typography>
                </Box>
                <Breadcrumbs separator="•" aria-label="breadcrumb">
            <DashboardBreadcrumbLink sx={{ fontSize: '0.875rem' }} />
                    <Typography color="text.primary" sx={{ fontSize: '0.875rem' }}>
                        Change Password
                    </Typography>
                </Breadcrumbs>
            </Box>


            <Card variant="outlined">
                <CardContent>
                    {/* <Grid container spacing={2} alignItems="center"> */}
                        <Grid container spacing={0} alignItems="center" marginTop={0}>
                            <Grid spacing={0} item>
                                <FormikProvider value={formik}>
                                    {(isError.status) && (
                                        <Alert severity="error" >{isError.msg}</Alert>
                                    )}

                                    {(successMsg != '') && (
                                        <Alert severity="success" >{successMsg}</Alert>
                                    )}
                                    <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                                        <Stack >
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} sm={3} >
                                                    <TextField
                                                        fullWidth
                                                        autoComplete="off"
                                                        type={showOldPassword ? 'text' : 'password'}
                                                        label="Old Password"
                                                        placeholder="Enter Old Password"
                                                        {...getFieldProps('oldPassword')}
                                                        InputLabelProps={{ shrink: true }}
                                                        InputProps={{
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <IconButton onClick={handleShowOldPassword} edge="end">
                                                                        <Iconify icon={showOldPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            ),
                                                            sx: {
                                                                color: 'white', // sets the input text color
                                                            },
                                                        }}
                                                        error={Boolean(touched.oldPassword && errors.oldPassword)}
                                                        helperText={touched.oldPassword && errors.oldPassword}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={3}>
                                                    <TextField
                                                        fullWidth
                                                        autoComplete="off"
                                                        type={showNewPassword ? 'text' : 'password'}
                                                        label="New Password"
                                                        placeholder="Enter New Password"
                                                        {...getFieldProps('newPassword')}
                                                        InputLabelProps={{ shrink: true }}
                                                        InputProps={{
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <IconButton onClick={handleShowNewPassword} edge="end">
                                                                        <Iconify icon={showNewPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            ),
                                                            sx: {
                                                                color: 'white', // sets the input text color
                                                            },
                                                        }}
                                                        error={Boolean(touched.newPassword && errors.newPassword)}
                                                        helperText={touched.newPassword && errors.newPassword}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={3}>
                                                    <TextField
                                                        fullWidth
                                                        autoComplete="off"
                                                        type={showConfirmPassword ? 'text' : 'password'}
                                                        label="Confirm Password"
                                                        placeholder="Enter Confirm Password"
                                                        {...getFieldProps('confirmPassword')}
                                                        InputLabelProps={{ shrink: true }}
                                                        InputProps={{
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <IconButton onClick={handleShowConfirmPassword} edge="end">
                                                                        <Iconify icon={showConfirmPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            ),
                                                            sx: {
                                                                color: 'white', // sets the input text color
                                                            },
                                                        }}
                                                        error={Boolean(touched.confirmPassword && errors.confirmPassword)}
                                                        helperText={touched.confirmPassword && errors.confirmPassword}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={3}>
                                                     <LoadingButton
                                                        size="large"
                                                        type="submit"
                                                        variant="contained"
                                                        loading={isSubmitting}
                                                        fullWidth
                                                        sx={{
                                                            
                                                            // marginLeft:"30px",
                                                            color:'#ffffff',
                                                            '&:hover': {
                                                            color:'#ffffff',
                                                            }
                                                        }}
                                                    >
                                                        Change Password
                                                    </LoadingButton>
                                                </Grid>
                                            </Grid>

                                        </Stack>

                                       
                                    </Form>
                                </FormikProvider>
                            </Grid>
                        </Grid>
                    {/* </Grid> */}
                </CardContent>
            </Card>
        </Container>
        </Page>
    );
}
